import { AxiosError, AxiosPromise, AxiosResponse } from 'axios'
import { Delete } from './Delete'
import { Filter } from './Devices'
import { Get } from './Get'
import { UserProfileObject } from './organization.types'
import { Post } from './Post'
import { Put } from './Put'
export interface UserResponse {
  id: string
  invitationStatus: string
  userName: string
  email: string
  phoneNumber: string
  firstname: string
  lastname: string
  avatarUrl: string
  forcePasswordChange: boolean
  profile: any
}

export interface PageUserResponse {
  results: UserResponse[]
  page: number
  pageCount: number
  pageSize: number
  queryCount: number
  firstRowIndex?: number
  lastRowIndex?: number
}

class UserServiceController {
  private licenseManagerUrl =
    process.env.LICENSE_MANAGER_URL ??
    window.location.protocol +
      '//' +
      window.location.hostname +
      '/license_manager'

  private userServerUrl = `${this.licenseManagerUrl}/users`
  public Get = {
    getAllUsers: (): AxiosPromise<PageUserResponse> => {
      const url = `${this.userServerUrl}`
     // console.log('getAllUsers url:', url)
      return Get(url)
    },
    // Trong UserService.ts
    getRolesToUserId: (userId: string): AxiosPromise<string[]> => {
      const url = `${this.userServerUrl}/${userId}/roles`
      //console.log('getRolesToUserId url:', url)
      return Get(url)
    },
  }

  public Put = {
    updateRolesUser: (userId: string, data: { roleName: string }) => {
      const url = `${this.licenseManagerUrl}/users/${userId}/roles`
      return Put(url, data)
    },
  }
  public Delete = {
    deleteRolesUser: (userId: string, roleNames: string[]) => {
      const url = `${this.licenseManagerUrl}/users/${userId}/roles`
      return Delete(url, roleNames)
    },
  }
}

export const UserService = new UserServiceController()
